import React from 'react';
import { Box, IconButton, Stack, SvgIcon, SwipeableDrawer, Typography } from '@mui/material';
import XMarkIcon from '@heroicons/react/24/outline/XMarkIcon';

const iOS = typeof navigator !== 'undefined' && /iPad|iPhone|iPod/.test(navigator.userAgent);

export function MobileBottomSheet({
  open,
  onClose,
  onOpen = () => { },
  title,
  children,
  footer,
  keepMounted = false,
  maxHeight = '88dvh',
}) {
  return (
    <SwipeableDrawer
      anchor="bottom"
      open={open}
      onClose={onClose}
      onOpen={onOpen}
      disableSwipeToOpen
      disableBackdropTransition={!iOS}
      disableDiscovery={iOS}
      ModalProps={{ keepMounted }}
      PaperProps={{
        sx: {
          borderTopLeftRadius: 20,
          borderTopRightRadius: 20,
          maxHeight,
          backgroundImage: 'none',
          bgcolor: 'background.paper',
          display: 'flex',
          flexDirection: 'column',
        },
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'center', pt: 1, pb: 0.5 }}>
        <Box sx={{ width: 40, height: 5, borderRadius: 3, bgcolor: 'divider' }} />
      </Box>
      {title && (
        <Stack
          direction="row"
          alignItems="center"
          sx={{ px: 2, pb: 1, borderBottom: '1px solid', borderColor: 'divider' }}
        >
          <Typography variant="subtitle1" sx={{ fontWeight: 700, mr: 'auto' }}>
            {title}
          </Typography>
          <IconButton size="small" onClick={onClose} aria-label="close">
            <SvgIcon fontSize="small">
              <XMarkIcon />
            </SvgIcon>
          </IconButton>
        </Stack>
      )}
      <Box sx={{ flex: 1, overflowY: 'auto', px: 2, py: 1.5 }}>
        {children}
      </Box>
      {footer && (
        <Box
          sx={{
            px: 2,
            pt: 1.5,
            pb: 'calc(12px + env(safe-area-inset-bottom))',
            borderTop: '1px solid',
            borderColor: 'divider',
          }}
        >
          {footer}
        </Box>
      )}
      {!footer && <Box sx={{ height: 'env(safe-area-inset-bottom)' }} />}
    </SwipeableDrawer>
  );
}
